import apiFetch from '../apiFetch'

export default function (data, token) {
  return apiFetch({endPoint: `Informes/getMostrarSeleccionInformePersonalizadoExtracciones`, method: 'POST', body: data, token: token})
}